<template>
  <v-chip :color="computedColor" :disabled="loading" dark small>
    {{ statusType(data.status) }}
  </v-chip>
</template>

<script>
export default {
  name: "transactionsStatusComponent",

  props: {
    data: Object,
    name: String
  },

  computed: {
    computedColor() {
      let color = '';
      switch (this.data.status) {
        case 'success':
          color = 'success'
          break;
        case 'fail':
        case 'stall':
          color = '#f13030'
          break;
        default:
          color = 'warning'
          break;
      }

      return color
    }
  },

  methods: {
    statusType(s) {
      switch (s) {
        case 'success':
          return 'موفق'
        case 'fail':
          return 'ناموفق'
        case 'stall':
          return 'ناموفق مطلق'
        default:
          return 'درحال بررسی'
      }
    }
  }
}
</script>

<style scoped>

</style>